export default "__VITE_PUBLIC_ASSET__6eac4340__"